// extracted by mini-css-extract-plugin
export default {"tooltip":"sF5KfKZabQDgwx42efHG","tooltipWhite":"xETlTyRM2tNkkgTLMuSc"};